import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Header from '../components/organisms/Header';

import MHeader from '../components/organisms/MHeader';

import HomePage from '../components/pages/HomePage/HomePage';

import BoBIsRouter from './BoBIsRouter';
import EducationRouter from './EducationRouter';
import FootprintsRouter from './FootprintsRouter';
import NoticeRouter from './NoticeRouter';

export default function MainRouter() {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Header />

      <MHeader />

      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path='/introduce/*' element={<BoBIsRouter />} />
        <Route path='/education/*' element={<EducationRouter />} />
        <Route path='/footprint/*' element={<FootprintsRouter />} />
        <Route path='/notice/*' element={<NoticeRouter />} />
      </Routes>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: '160px',
    '@media only screen and (max-width: 768px)': {
      paddingTop: '64px',
    },
  },
}));
